import { FC, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { captureException } from '@sentry/react';

import * as markdownService from 'services/markdownService';
import { useTranslations } from 'hooks/useTranslations';

import PageState from 'components/UI/Page/PageState';
import { IconType } from 'components/UI/Icon';

import { Container } from './styled';

type Props = {
  documentUrl: string;
};

const RenderMarkdown: FC<Props> = ({ documentUrl }) => {
  const t = useTranslations();

  // State
  const [markdownSource, setMarkdownSource] = useState<string>('');
  const [isError, setIsError] = useState<boolean>(false);

  // Fetch markdown
  useEffect(() => {
    const fetchMarkdown = async (uri: string) => {
      try {
        const markdown = await markdownService.fetchMarkdown(uri);
        setMarkdownSource(markdown);
      } catch (err) {
        captureException(err);
        setIsError(true);
      }
    };
    if (documentUrl) {
      fetchMarkdown(documentUrl);
    }
  }, [documentUrl]);

  if (isError) {
    return (
      <PageState
        iconType={IconType.Error}
        title={t('terms_of_use.error_title')}
        description={t('terms_of_use.error_description')}
        small
      />
    );
  }

  return (
    <Container>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {markdownSource}
      </ReactMarkdown>
    </Container>
  );
};

export default RenderMarkdown;
